import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsFormControl, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import BsModalForm from '../../collection/bootstrap/BsModalForm';
import Loading from '../../collection/icons/Loading';
import HiddenInput from '../../collection/inputs/HiddenInput';
import { apiForm, apiGet } from '../../utils/api';
import FormCheckDoubleLabel from '../project/FormCheckDoubleLabel';

export default function SolicitudVestimenta(props) {
    const isNew = props.idSolicitudVestimenta < 1;

    const updateData = async () => await apiGet("vestuario/get/" + props.idSolicitudVestimenta);

    const checkData = formData => {
        let errors = {};
        // Prenda
        const prenda = formData.get("prenda");
        if (!prenda) {
            errors["prenda"] = "Campo obligatorio";
        }
        // Talla
        const talla = formData.get("talla");
        if (!talla) {
            errors["talla"] = "Campo obligatorio";
        }
        // Motivo
        const motivo = formData.get("motivo");
        if (!motivo) {
            errors["motivo"] = "Campo obligatorio";
        }
        // Imagen
        const imagen = formData.get("imagen");
        if (isNew && (motivo != 1 && motivo != 4) && imagen.size == 0) {
            errors["imagen"] = "Campo obligatorio";
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("vestuario/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nueva solicitud" : "Editar solicitud"}
            show={true}
            onHide={props.onHide}
            saveOnEnter>
            <SolicitudVestimentaForm />
        </BsModalForm>
    );
}

function SolicitudVestimentaForm(props) {
    const data = props.data;
    const errors = props.errors;

    // input values
    const [epi, setEpi] = useState(!!data.epi);
    const [prenda, setPrenda] = useState(data.prenda ? data.prenda : 0);
    const [motivo, setMotivo] = useState(data.motivo ? data.motivo : 0);

    // lists
    const [listPrendas, setListPrendas] = useState();
    const [listTallas, setListTallas] = useState();
    const [listMotivos, setListMotivos] = useState();

    const [keyClearPrenda, setKeyClearPrenda] = useState(Math.random());
    const [keyClearTalla, setKeyClearTalla] = useState(Math.random());

    // update lists
    const updatePrendas = async () => {
        await setListPrendas(await apiGet("vestuario/listPrendas/" + epi));
        setKeyClearPrenda(Math.random());
        setPrenda(data.prenda ? data.prenda : 0);
    };
    const updateTallas = async () => {
        await setListTallas(await apiGet("vestuario/listTallas/" + prenda));
        setKeyClearTalla(Math.random());
    };
    const updateMotivos = async () => {
        await setListMotivos(await apiGet("vestuario/listMotivos"));
        setKeyClearTalla(Math.random());
    };

    // update triggers
    useEffect(() => {
        updatePrendas();
        updateTallas();
        updateMotivos();
    }, []);
    useEffect(() => { updatePrendas(); }, [epi]);
    useEffect(() => { updateTallas(); }, [prenda]);

    return (listPrendas && listMotivos) ? <>
        <Row>
            <Col md={4}></Col>
            <Col md={8}>
                <FormCheckDoubleLabel
                    /* Ropa / EPI */
                    leftLabel="Ropa" rightLabel="EPI"
                    name="epi" defaultChecked={data.epi}
                    onChange={(e) => setEpi(e.target.checked)} />
            </Col>
        </Row>
        <BsFormSelect
            /* Prenda */
            label="Prenda" name="prenda"
            value={data.prenda} error={errors.prenda}
            options={listPrendas} key={keyClearPrenda}
            onChange={(e) => setPrenda(e.value)}
            className="mt-3" />
        {(listTallas && listTallas.length > 1) ?
            <BsFormSelect
                /* Talla */
                label="Talla" name="talla"
                value={data.talla} error={errors.talla}
                options={listTallas} key={keyClearTalla}
                className="mt-3" /> :
            <HiddenInput name="talla" value={38} /> /* talla única */
        }
        <BsFormSelect
            /* Motivo */
            label="Motivo" name="motivo"
            value={data.motivo} error={errors.motivo}
            options={listMotivos}
            onChange={(e) => setMotivo(e.value)}
            className="mt-3" />
        {(!!motivo && (motivo != 1 && motivo != 4)) &&  // motivo 1 = Pérdida, motivo 4 = Pedido anual
            <BsFormControl
                /* Imagen */
                label="Imagen" name="imagen"
                value="" error={errors.imagen}
                className="mt-3" type="file" />}
    </> : <Loading />;
}
